<template>
	<div class="ai-points">
		<Card class="ai-card" title="筛选条件">
			<Form class="filter-form" :label-width="100">
				<div class="filter-row">
					<FormItem label="订单号">
						<Input v-model.trim="search.order_sn" placeholder="请输入订单号" clearable />
					</FormItem>
					<FormItem label="支付单号">
						<Input v-model.trim="search.transaction_id" placeholder="请输入支付单号" clearable />
					</FormItem>
					<FormItem label="云端账号ID">
						<Input v-model.trim="search.cloud_id" placeholder="请输入云端账号ID" clearable />
					</FormItem>
					<FormItem label="套餐名称">
						<Input v-model.trim="search.package_name" placeholder="请输入套餐名称" clearable />
					</FormItem>
					<FormItem label="支付方式">
						<Select v-model="search.pay_type" placeholder="请选择支付方式" clearable>
							<Option :value="-1">全部</Option>
							<Option v-for="item in payTypeOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
						</Select>
					</FormItem>
					<FormItem label="订单状态">
						<Select v-model="search.order_status" placeholder="请选择订单状态" clearable>
							<Option :value="-1">全部</Option>
							<Option v-for="item in orderStatusOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
						</Select>
					</FormItem>
					<FormItem label="发放状态">
						<Select v-model="search.grant_status" placeholder="请选择发放状态" clearable>
							<Option :value="-1">全部</Option>
							<Option v-for="item in grantStatusOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
						</Select>
					</FormItem>
					<FormItem label="支付时间">
						<DatePicker
							type="daterange"
							v-model="search.pay_time"
							placeholder="请选择支付时间范围"
							style="width:100%;"
						/>
					</FormItem>
					<div class="btn-group">
						<Button type="primary" icon="ios-search" @click="handleSearch">搜索</Button>
						<Button icon="ios-refresh" @click="resetSearch">重置</Button>
					</div>
				</div>
			</Form>
		</Card>

		<Card class="ai-card" title="订单列表">
			<Table
				:data="tableData"
				:columns="columns"
				:loading="loading"
				border
				stripe
				:no-data-text="'暂无订单数据'"
			>
				<template slot="status" slot-scope="{ row }">
					<Tag :color="getOrderStatusColor(row.order_status)">
						{{ getOrderStatusText(row.order_status) }}
					</Tag>
				</template>
				<template slot="grant_status" slot-scope="{ row }">
					<Tag :color="getGrantStatusColor(row.grant_status)">
						{{ getGrantStatusText(row.grant_status) }}
					</Tag>
				</template>
				<template slot="pay_type" slot-scope="{ row }">
					{{ getPayTypeText(row.pay_type) }}
				</template>
				<template slot="resource" slot-scope="{ row }">
					<div class="points-line">
						<span>套餐资源点：{{ row.resource_points }}</span>
						<span>到账：{{ row.granted_points }}</span>
					</div>
				</template>
			</Table>
			<div class="table-footer">
				<Page
					:total="search.total"
					:current="search.page"
					:page-size="search.pageSize"
					:page-size-opts="[15, 30, 50]"
					show-total
					show-sizer
					@on-change="pageChange"
					@on-page-size-change="pageSizeChange"
				/>
			</div>
		</Card>
	</div>
</template>

<script>
const defaultSearch = () => ({
	total: 0,
	pageSize: 15,
	page: 1,
	order_sn: '',
	transaction_id: '',
	cloud_id: '',
	package_name: '',
	pay_type: -1,
	order_status: -1,
	grant_status: -1,
	pay_time: []
})

export default {
	data() {
		return {
			search: defaultSearch(),
			loading: false,
			tableData: [],
			payTypeOptions: [
				{ value: 1, label: '微信' },
				{ value: 2, label: '支付宝' },
				{ value: 3, label: '线下' }
			],
			orderStatusOptions: [
				{ value: 0, label: '待支付' },
				{ value: 1, label: '已支付' },
				{ value: 2, label: '已取消' },
				{ value: 3, label: '退款中' },
				{ value: 4, label: '已退款' }
			],
			grantStatusOptions: [
				{ value: 0, label: '待同步' },
				{ value: 1, label: '同步成功' },
				{ value: 2, label: '失败待重试' }
			]
		}
	},
	computed: {
		columns() {
			return [
				{ title: '订单号', key: 'order_sn', minWidth: 170, ellipsis: true, tooltip: true },
				{ title: '支付单号', key: 'transaction_id', minWidth: 170, ellipsis: true, tooltip: true },
				{ title: '云端账号ID', key: 'cloud_id', minWidth: 120 },
				{ title: '套餐名称', key: 'package_name', minWidth: 140, ellipsis: true, tooltip: true },
				{ title: '资源点', slot: 'resource', minWidth: 180 },
				{
					title: '支付金额(元)',
					key: 'pay_amount',
					align: 'right',
					minWidth: 130,
					render: (h, { row }) => h('span', this.formatPrice(row.pay_amount))
				},
				{ title: '支付方式', slot: 'pay_type', minWidth: 110 },
				{ title: '订单状态', slot: 'status', minWidth: 110, align: 'center' },
				{ title: '发放状态', slot: 'grant_status', minWidth: 110, align: 'center' },
				{ title: '支付时间', key: 'pay_time', minWidth: 160 },
				{ title: '创建时间', key: 'created_at', minWidth: 160 }
			]
		}
	},
	created() {
		this.init()
	},
	methods: {
		handleSearch() {
			this.search.page = 1
			this.init()
		},
		resetSearch() {
			const reset = defaultSearch()
			reset.pageSize = this.search.pageSize
			Object.assign(this.search, reset)
			this.init()
		},
		formatPrice(value) {
			const num = Number(value || 0)
			return num.toFixed(2)
		},
		getPayTypeText(type) {
			const item = this.payTypeOptions.find(v => v.value === type)
			return item ? item.label : '-'
		},
		getOrderStatusText(status) {
			const item = this.orderStatusOptions.find(v => v.value === status)
			return item ? item.label : '-'
		},
		getOrderStatusColor(status) {
			switch (status) {
				case 1: return 'success'
				case 2: return 'default'
				case 3: return 'warning'
				case 4: return 'error'
				default: return 'default'
			}
		},
		getGrantStatusText(status) {
			const item = this.grantStatusOptions.find(v => v.value === status)
			return item ? item.label : '-'
		},
		getGrantStatusColor(status) {
			switch (status) {
				case 1: return 'success'
				case 2: return 'error'
				default: return 'default'
			}
		},
		init() {
			this.loading = true
			const params = Object.assign({}, this.search)
			this.requestApi('/adm/get_ai_points_order_list', { search: params })
				.then(res => {
					if (res.status === 1) {
						this.tableData = res.data.data || []
						this.search.total = res.data.total || 0
					} else {
						this.alertErr(res.msg || '获取订单失败')
					}
				})
				.finally(() => {
					this.loading = false
				})
		},
		pageChange(page) {
			this.search.page = page
			this.init()
		},
		pageSizeChange(size) {
			this.search.pageSize = size
			this.search.page = 1
			this.init()
		}
	}
}
</script>

<style scoped>
.ai-points {
	padding-bottom: 16px;
}

.ai-card {
	margin-bottom: 16px;
}

.filter-form {
	padding: 0 8px;
	width: 100%;
}

.filter-row {
	display: flex;
	flex-wrap: wrap;
	gap: 12px 16px;
	align-items: flex-end;
}

.filter-row .ivu-form-item {
	flex: 1 1 240px;
	margin-bottom: 12px;
}

.btn-group {
	display: flex;
	gap: 8px;
	margin-bottom: 12px;
}

.points-line {
	display: flex;
	gap: 12px;
	color: #606266;
	font-size: 12px;
}

.table-footer {
	margin-top: 16px;
	text-align: right;
}
</style>
